<template>
  <div
    class="image-upload-shell"
    :class="{ 'is-dragover': dragUpload && nativeDragOver }"
    @dragenter.prevent="handleDragEnter"
    @dragover.prevent="handleDragOver"
    @dragleave="handleDragLeave"
    @drop.prevent="handleNativeDrop"
  >
    <el-upload
      ref="uploadWidget"
      action="#"
      list-type="picture-card"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove"
      class="upload_list_warp"
      v-model="uploadImgList"
      :file-list="uploadImgList"
      :limit="maxCount"
      :multiple="multiple"
      :on-exceed="handleExceed"
      :before-upload="beforeAvatarUpload"
      :http-request="handleFileUpload"
    >
      <i slot="default" class="el-icon-plus"></i>
      <div
        slot="file"
        slot-scope="{ file }"
        class="sortable-image-item"
        :class="{ 'is-sortable': sortable, 'is-dragging': isDragging(file) }"
      >
        <img
          class="el-upload-list__item-thumbnail"
          :src="file.url"
          alt="已上传图片"
          draggable="false"
        />
        <span v-if="sortable" class="sort-handle" title="拖拽调整顺序">
          <i class="el-icon-rank"></i>
        </span>
        <span class="el-upload-list__item-actions">
          <span
            class="el-upload-list__item-preview"
            @click="handlePictureCardPreview(file)"
          >
            <i class="el-icon-zoom-in"></i>
          </span>
          <span
            v-if="!disabled"
            class="el-upload-list__item-delete"
            @click="handleRemove(file)"
          >
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>
    <div class="el-upload__tip">
      支持 jpg、jpeg、png、gif，单张不超过 50MB
      <span v-if="dragUpload"
        >；可拖入上传<span v-if="sortable">，拖动缩略图可排序</span></span
      >
    </div>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img class="preview-image" :src="dialogImageUrl" alt="图片预览" />
    </el-dialog>
  </div>
</template>

<script>
import { uploadImage } from "@/api/common";
import { UPLOAD_IMG_TYPE } from "@/utils/enumUtile";
import { getFileName } from "@/utils/utils";
import { Message } from "element-ui";
import { getToken } from "@/utils/auth";
import Sortable from "sortablejs";

export default {
  props: {
    typeProps: UPLOAD_IMG_TYPE,
    paramsType: String,
    model: Array,
    maxCount: Number,
    multiple: {
      type: Boolean,
      default: false
    },
    sortable: {
      type: Boolean,
      default: false
    },
    dragUpload: {
      type: Boolean,
      default: false
    },
    aspectRatio: {
      type: Number,
      default: 0
    },
    aspectRatioTip: {
      type: String,
      default: "图片宽高比例不符合要求"
    }
  },
  watch: {
    model(value) {
      this.setImgList(value);
      this.$nextTick(() => this.initSortable());
    }
  },
  data() {
    return {
      uploadImgList: [],
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      tokenData: getToken(),
      nativeDragOver: false,
      draggingKey: null,
      uidSeed: 0,
      sortableInstance: null
    };
  },
  created() {
    this.setImgList(this.model || []);
  },
  mounted() {
    this.$nextTick(() => this.initSortable());
  },
  beforeDestroy() {
    if (this.sortableInstance) this.sortableInstance.destroy();
    this.sortableInstance = null;
  },
  methods: {
    initSortable() {
      if (!this.sortable || this.sortableInstance) return;
      const widget = this.$refs.uploadWidget;
      const root = widget && widget.$el;
      const list = root && root.querySelector(".el-upload-list");
      if (!list) return;
      this.sortableInstance = Sortable.create(list, {
        animation: 120,
        draggable: ".el-upload-list__item",
        handle: ".sortable-image-item",
        filter: ".el-upload-list__item-actions",
        preventOnFilter: false,
        forceFallback: true,
        fallbackOnBody: true,
        fallbackTolerance: 3,
        ghostClass: "image-sortable-ghost",
        chosenClass: "image-sortable-chosen",
        dragClass: "image-sortable-drag",
        onStart: () => {
          this.nativeDragOver = false;
        },
        onEnd: ({ oldIndex, newIndex }) => {
          if (
            oldIndex === undefined ||
            newIndex === undefined ||
            oldIndex === newIndex
          )
            return;
          const moved = this.uploadImgList.splice(oldIndex, 1)[0];
          if (!moved) return;
          this.uploadImgList.splice(newIndex, 0, moved);
          this.emitValue();
        }
      });
    },
    createKey(item, index) {
      if (item && item._uploadKey) return item._uploadKey;
      if (item && item.uid !== undefined && item.uid !== null)
        return `uid-${item.uid}`;
      this.uidSeed += 1;
      return `${(item && (item.dbUrl || item.url || item.name)) ||
        "image"}-${index}-${this.uidSeed}`;
    },
    setImgList(images) {
      this.uploadImgList = (Array.isArray(images) ? images : []).map(
        (item, index) => ({
          ...item,
          _uploadKey: this.createKey(item, index)
        })
      );
    },
    emitValue() {
      this.$emit("valueFunc", this.paramsType, this.uploadImgList.slice());
    },
    handleRemove(file) {
      const index = this.uploadImgList.findIndex(
        item => item._uploadKey === file._uploadKey
      );
      if (index !== -1) {
        this.uploadImgList.splice(index, 1);
        this.emitValue();
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url || file.dbUrl;
      this.dialogVisible = true;
    },
    async handleFileUpload(request) {
      const loading = this.openLoading();
      try {
        await this.uploadOne(request.file);
      } finally {
        loading.close();
      }
    },
    openLoading() {
      return this.$loading({
        lock: true,
        text: "上传图片中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.35)"
      });
    },
    async uploadOne(file) {
      const resp = await uploadImage({ type: this.typeProps, file });
      if (!resp || resp.bizcode !== 100) {
        throw new Error((resp && resp.msg) || "上传图片失败");
      }
      const item = {
        name: getFileName(resp.data.dbUrl),
        dbUrl: resp.data.dbUrl,
        url: resp.data.accessUrl || resp.data.dbUrl
      };
      item._uploadKey = this.createKey(item, this.uploadImgList.length);
      this.uploadImgList.push(item);
      this.emitValue();
      return item;
    },
    handleExceed() {
      this.$message.warning(`当前限制选择 ${this.maxCount} 个文件`);
    },
    async beforeAvatarUpload(file) {
      const isImage = ["image/jpeg", "image/png", "image/gif"].includes(
        file.type
      );
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isImage) this.$message.error("图片只能是 jpg、jpeg、png、gif 格式");
      if (!isLt50M) this.$message.error("单张图片不能超过 50MB");
      if (!isImage || !isLt50M) throw new Error("图片格式或大小不符合要求");
      if (this.aspectRatio > 0) {
        const validRatio = await new Promise(resolve => {
          const image = new Image();
          const url = URL.createObjectURL(file);
          image.onload = () => {
            const ratio = image.width / image.height;
            URL.revokeObjectURL(url);
            resolve(Math.abs(ratio - this.aspectRatio) <= 0.01);
          };
          image.onerror = () => {
            URL.revokeObjectURL(url);
            resolve(false);
          };
          image.src = url;
        });
        if (!validRatio) {
          this.$message.error(this.aspectRatioTip);
          throw new Error(this.aspectRatioTip);
        }
      }
      return true;
    },
    handleDragEnter() {
      if (this.dragUpload && !this.draggingKey) this.nativeDragOver = true;
    },
    handleDragOver() {
      if (this.dragUpload && !this.draggingKey) this.nativeDragOver = true;
    },
    handleDragLeave(event) {
      if (!event.currentTarget.contains(event.relatedTarget))
        this.nativeDragOver = false;
    },
    async handleNativeDrop(event) {
      this.nativeDragOver = false;
      if (!this.dragUpload || this.draggingKey) return;
      const files = Array.from(
        (event.dataTransfer && event.dataTransfer.files) || []
      );
      if (!files.length) return;
      const remaining = Math.max(
        0,
        (this.maxCount || files.length) - this.uploadImgList.length
      );
      if (remaining === 0) {
        this.handleExceed();
        return;
      }
      const accepted = files.slice(0, remaining);
      if (accepted.length < files.length) this.handleExceed();
      const loading = this.openLoading();
      try {
        for (const file of accepted) {
          await this.beforeAvatarUpload(file);
          await this.uploadOne(file);
        }
      } catch (error) {
        Message({
          message: error.message || "上传图片失败",
          type: "error",
          duration: 3000
        });
      } finally {
        loading.close();
      }
    },
    isDragging(file) {
      return this.draggingKey && file._uploadKey === this.draggingKey;
    },
    handleSortStart(file, event) {
      if (!this.sortable) return;
      this.draggingKey = file._uploadKey;
      event.dataTransfer.effectAllowed = "move";
      event.dataTransfer.setData("text/plain", file._uploadKey);
      this.setLightweightDragImage(event, "调整图片顺序");
    },
    handleSortOver(event) {
      if (this.sortable && this.draggingKey)
        event.dataTransfer.dropEffect = "move";
    },
    handleSortDrop(targetFile) {
      if (!this.sortable || !this.draggingKey) return;
      if (targetFile._uploadKey === this.draggingKey) {
        this.releaseDragState();
        return;
      }
      const fromIndex = this.uploadImgList.findIndex(
        item => item._uploadKey === this.draggingKey
      );
      const toIndex = this.uploadImgList.findIndex(
        item => item._uploadKey === targetFile._uploadKey
      );
      if (fromIndex === -1 || toIndex === -1) {
        this.releaseDragState();
        return;
      }
      const moved = this.uploadImgList.splice(fromIndex, 1)[0];
      this.uploadImgList.splice(toIndex, 0, moved);
      this.emitValue();
      this.releaseDragState();
    },
    handleSortEnd() {
      this.releaseDragState();
    },
    releaseDragState() {
      this.draggingKey = null;
      this.nativeDragOver = false;
    },
    setLightweightDragImage(event, text) {
      if (
        !event.dataTransfer ||
        typeof event.dataTransfer.setDragImage !== "function"
      )
        return;
      const ghost = document.createElement("div");
      ghost.className = "image-sort-drag-ghost";
      ghost.textContent = text;
      document.body.appendChild(ghost);
      event.dataTransfer.setDragImage(ghost, 72, 20);
      window.requestAnimationFrame(() => {
        if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
      });
    }
  }
};
</script>

<style scoped lang="scss">
.image-upload-shell {
  position: relative;
  min-height: 150px;
  padding: 10px;
  border: 1px dashed transparent;
  border-radius: 6px;
  transition: border-color 180ms ease, background-color 180ms ease;
}

.image-upload-shell.is-dragover {
  border-color: #409eff;
  background: #ecf5ff;
}

.sortable-image-item {
  position: relative;
  width: 100%;
  height: 100%;
  user-select: none;
  -webkit-user-drag: none;
}

.sortable-image-item.is-sortable {
  cursor: grab;
}

.sortable-image-item.is-dragging {
  opacity: 0.45;
}

.sort-handle {
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  color: #fff;
  background: rgba(31, 35, 41, 0.72);
  border-radius: 4px;
}

.el-upload__tip {
  margin: 0 0 10px;
  color: #606266;
  line-height: 24px;
}

.preview-image {
  display: block;
  max-width: 100%;
  max-height: 70vh;
  margin: 0 auto;
  object-fit: contain;
}

@media (prefers-reduced-motion: reduce) {
  .image-upload-shell {
    transition: none;
  }
}

::v-deep .el-upload-list__item-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #f5f7fa;
  pointer-events: none;
  user-select: none;
  -webkit-user-drag: none;
}

::v-deep .el-upload-list__item-actions,
.sort-handle {
  pointer-events: auto;
}

::v-deep .image-sortable-chosen,
::v-deep .image-sortable-drag {
  cursor: grabbing;
}

::v-deep .image-sortable-ghost {
  opacity: 0.35;
}
</style>

<style>
.image-sort-drag-ghost {
  position: fixed;
  top: -1000px;
  left: -1000px;
  z-index: -1;
  width: 144px;
  height: 40px;
  color: #ffffff;
  font-size: 13px;
  line-height: 40px;
  text-align: center;
  background: rgba(31, 35, 41, 0.88);
  border-radius: 4px;
  pointer-events: none;
}
</style>
